import script from "./VendorSignup.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorSignup.vue?vue&type=script&setup=true&lang=js"

import "./VendorSignup.vue?vue&type=style&index=0&id=376f339c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-376f339c"]])

export default __exports__